import LiveInputsTextInput from './text_input'
import { validateInput } from '@app/application/reconciliation/handlers/validators/text-input-validator'
import $ from 'jquery'

export default class LiveInputsDateInput extends LiveInputsTextInput {
  inputFilter() {
    return "[data-behaviour~='live-inputs-date-input']"
  }

  constructor(liveInputs) {
    super(liveInputs)
    this.handleHideEvent = this.handleHideEvent.bind(this)
    this.handleChangeEvent = this.handleChangeEvent.bind(this)
    this.handleBlurEvent = this.handleBlurEvent.bind(this)
    this.handleFocusEvent = this.handleFocusEvent.bind(this)
    this.initializeListener()
  }

  initializeListener() {
    this.liveInputs.on('hide', this.inputFilter(), this.handleHideEvent)
    this.liveInputs.on('change', this.inputFilter(), this.handleChangeEvent)
    this.liveInputs.on('blur', this.inputFilter(), this.handleBlurEvent)
    this.liveInputs.on('focus', this.inputFilter(), this.handleFocusEvent)
  }

  handleHideEvent(event) {
    setTimeout(() => {
      this.update($(event.target))
    })
  }

  handleChangeEvent(event) {
    validateInput(event.target)
    this.update($(event.target))
  }
  handleBlurEvent(event) {
    const { target } = event
    if (target.value !== target.dataset['originalValue']) {
      this.updateTabDirection(event)
    }
  }

  handleFocusEvent(event) {
    this.initializeOriginalValue($(event.target))
  }

  teardown() {
    this.liveInputs.off('hide', this.inputFilter(), this.handleHideEvent)
    this.liveInputs.off('change', this.inputFilter(), this.handleChangeEvent)
    this.liveInputs.off('blur', this.inputFilter(), this.handleBlurEvent)
    this.liveInputs.off('focus', this.inputFilter(), this.handleFocusEvent)
  }
}
